import universityCodes from '../../utility/universityCodes';

export default {
  DEFAULT: {
    personalInfo: 'Personal Info',
    summary: 'Summary',
    education: 'Education',
    skills: 'Skills',
    projects: 'Projects',
    researchExperience: 'Research Experience',
    workExperience: 'Work Experience',
    awardsAndHonors: 'Awards & Honors',
    volunteerWork: 'Volunteer Work',
    certifications: 'Certifications',
    hobbiesAndInterests: 'Hobbies & Interests',
    leadership: 'Leadership',
    associations: 'Associations',
    extraCurricular: 'Extra Curricular Activities',
    publications: 'Publications',
    languages: 'Languages',
    courses: 'Courses',
    conferences: 'Conferences/Presentations',
    patents: 'Patents',
    testScores: 'Test Scores',
    references: 'References',
  },
  [universityCodes.WSU_EDU]: {
    summary: 'Summary of Qualifications',
    workExperience: 'Experience',
  },
  [universityCodes.SAGE_HILL_SCHOOL]: {
    associations: 'Arts',
    courses: 'Athletics',
  },
};
